import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
} from "reactstrap";

import {
    FiClock,
    FiDollarSign,
    FiUsers,
    FiVideo,
    FiCheckCircle,
    FiArrowRight,
    FiCreditCard,
    FiTag,
    FiMonitor,
} from "react-icons/fi";

import "./FeesStructure.css";
import SEO from "../../components/common/seo/SEO";


function FeesStructure() {
    return (

        <>
            <SEO
                title="Fees Structure | FeesWorth"

                description="View FeesWorth CAD Automation & Customization Training fees. Get details about course duration, USD 999 or INR 79,000 fees, programming language training, CAD API training, installments, group discounts and online training."

                keywords="CAD Automation Course Fees, CAD Customization Course Fees, CAD Automation Training Fees, CAD Customization Training Fees, CAD API Training Fees, CAD Programming Course Fees, CAD Automation Course Price, CAD Customization Course Price, CAD API Training, CAD Automation Training, CAD Customization Training, FeesWorth"

                canonical="https://feesworth.com/fees-structure"
            />

            <div className="fees-page">

                {/* =====================================================
                HERO SECTION
            ===================================================== */}

                <section className="fees-hero">

                    <Container>

                        <div className="fees-hero-content">

                            <span className="fees-hero-badge">
                                CAD Training Program
                            </span>

                            <h1>
                                Fees Structure
                            </h1>

                            <p>
                                CAD Automation & Customization Training
                            </p>

                            <div className="fees-hero-line"></div>

                        </div>

                    </Container>

                </section>


                {/* =====================================================
                MAIN CONTENT
            ===================================================== */}

                <section className="fees-main">

                    <Container>

                        <Row className="g-4 justify-content-center">

                            {/* =================================================
                            LEFT CONTENT
                        ================================================= */}

                            <Col
                                lg="7"
                                md="12"
                            >

                                <div className="fees-introduction">

                                    <span className="fees-section-label">
                                        CAD Automation & Customization
                                    </span>

                                    <h2>
                                        Upgrade Your CAD Skills
                                    </h2>

                                    <p>
                                        If you are a CAD Design Engineer, Draftsman,
                                        or CAD user with strong knowledge in Part
                                        Modelling, Assembly, and Drafting in any CAD
                                        software — and you want to upgrade your
                                        skills to customize CAD tools or automate
                                        repetitive tasks, this course is designed
                                        for you.
                                    </p>

                                </div>


                                {/* =================================================
                                DURATION
                            ================================================= */}

                                <Card className="fees-info-card">

                                    <CardBody>

                                        <div className="fees-info-icon">
                                            <FiClock />
                                        </div>

                                        <div className="fees-info-content">

                                            <h3>
                                                Duration
                                            </h3>

                                            <p>
                                                2 Months (45 to 50 Hours)
                                            </p>

                                        </div>

                                    </CardBody>

                                </Card>


                                {/* =================================================
                                FEES
                            ================================================= */}

                                <Card className="fees-info-card fees-price-card">

                                    <CardBody>

                                        <div className="fees-info-icon fees-price-icon">
                                            <FiDollarSign />
                                        </div>

                                        <div className="fees-info-content">

                                            <h3>
                                                Fees
                                            </h3>

                                            <div className="fees-price">
                                                <span className="fees-currency">
                                                    USD
                                                </span>

                                                <strong>
                                                    999
                                                </strong>

                                            </div>

                                            <div className="fees-or">
                                                OR
                                            </div>

                                            <div className="fees-price">
                                                <span className="fees-currency">
                                                    INR
                                                </span>

                                                <strong>
                                                    79,000
                                                </strong>
                                            </div>

                                            <div className="fees-price-details">

                                                <div className="fees-detail-item">
                                                    <FiCheckCircle />

                                                    <span>
                                                        Fees includes programming
                                                        language training. and any one
                                                        CAD API Training.
                                                    </span>
                                                </div>

                                                <div className="fees-detail-item">
                                                    <FiCreditCard />

                                                    <span>
                                                        Fees can be paid in multiple
                                                        installments.
                                                    </span>
                                                </div>

                                            </div>

                                        </div>

                                    </CardBody>

                                </Card>


                                {/* =================================================
                                OFFERS / DISCOUNTS
                            ================================================= */}

                                <Card className="fees-info-card">

                                    <CardBody>

                                        <div className="fees-info-icon fees-offer-icon">
                                            <FiTag />
                                        </div>

                                        <div className="fees-info-content">

                                            <h3>
                                                Offers / Discounts
                                            </h3>

                                            <p>
                                                We always offer group discounts
                                                ranging from 5% to 45% each when
                                                you enroll as a group of students.
                                            </p>

                                            <p className="fees-secondary-text">
                                                Special offers and discounts
                                                available on select occasions.
                                            </p>

                                        </div>

                                    </CardBody>

                                </Card>


                                {/* =================================================
                                MODE OF TRAINING
                            ================================================= */}

                                <Card className="fees-info-card">

                                    <CardBody>

                                        <div className="fees-info-icon fees-training-icon">
                                            <FiVideo />
                                        </div>

                                        <div className="fees-info-content">

                                            <h3>
                                                Mode of Training
                                            </h3>

                                            <p>
                                                Live, Interactive & Online using
                                                Zoom or Teams Meeting. Recorded
                                                videos will be available during
                                                the training period.
                                            </p>

                                        </div>

                                    </CardBody>

                                </Card>

                            </Col>


                            {/* =================================================
                            RIGHT PRICING CARD
                        ================================================= */}

                            <Col
                                lg="5"
                                md="12"
                            >

                                <div className="fees-sidebar">

                                    <Card className="fees-pricing-card">

                                        <CardBody>

                                            <div className="fees-card-top">

                                                <span>
                                                    CAD Automation Training
                                                </span>

                                                <FiMonitor />

                                            </div>


                                            <h3>
                                                Invest in Your
                                                <span>
                                                    CAD Future
                                                </span>
                                            </h3>


                                            <p className="fees-card-description">
                                                Build practical CAD automation
                                                skills and learn how to customize
                                                CAD tools for real-world
                                                applications.
                                            </p>


                                            {/* PRICE */}

                                            <div className="fees-main-price">

                                                <div className="fees-price-usd">

                                                    <small>
                                                        USD
                                                    </small>

                                                    <strong>
                                                        $999
                                                    </strong>

                                                </div>

                                                <div className="fees-price-divider">
                                                    /
                                                </div>

                                                <div className="fees-price-inr">

                                                    <small>
                                                        INR
                                                    </small>

                                                    <strong>
                                                        ₹79,000
                                                    </strong>

                                                </div>

                                            </div>


                                            {/* FEATURES */}

                                            <div className="fees-card-features">

                                                <div>
                                                    <FiCheckCircle />

                                                    <span>
                                                        2 Months Training
                                                    </span>
                                                </div>

                                                <div>
                                                    <FiCheckCircle />

                                                    <span>
                                                        45 to 50 Hours
                                                    </span>
                                                </div>

                                                <div>
                                                    <FiCheckCircle />

                                                    <span>
                                                        Programming Language Training
                                                    </span>
                                                </div>

                                                <div>
                                                    <FiCheckCircle />

                                                    <span>
                                                        Any One CAD API Training
                                                    </span>
                                                </div>

                                                <div>
                                                    <FiCheckCircle />

                                                    <span>
                                                        Recorded Training Videos
                                                    </span>
                                                </div>

                                                <div>
                                                    <FiCheckCircle />

                                                    <span>
                                                        Multiple Installments Available
                                                    </span>
                                                </div>

                                            </div>


                                            <Button
                                                href="/contact"
                                                className="fees-enquire-btn"
                                            >
                                                Enquire Now

                                                <FiArrowRight />

                                            </Button>


                                            <div className="fees-card-note">

                                                <FiUsers />

                                                <span>
                                                    Group discounts available from
                                                    5% to 45%
                                                </span>

                                            </div>

                                        </CardBody>

                                    </Card>


                                    {/* =================================================
                                    QUICK INFORMATION
                                ================================================= */}

                                    <div className="fees-quick-info">

                                        <div className="fees-quick-item">

                                            <FiClock />

                                            <div>
                                                <strong>
                                                    Duration
                                                </strong>

                                                <span>
                                                    2 Months
                                                </span>
                                            </div>

                                        </div>


                                        <div className="fees-quick-item">

                                            <FiVideo />

                                            <div>
                                                <strong>
                                                    Training
                                                </strong>

                                                <span>
                                                    Live & Online
                                                </span>
                                            </div>

                                        </div>


                                        <div className="fees-quick-item">

                                            <FiTag />

                                            <div>
                                                <strong>
                                                    Discounts
                                                </strong>

                                                <span>
                                                    Group Discounts Available
                                                </span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </Col>

                        </Row>

                    </Container>

                </section>


                {/* =====================================================
                BOTTOM CTA
            ===================================================== */}

                <section className="fees-cta">

                    <Container>

                        <div className="fees-cta-content">

                            <div>

                                <span>
                                    Ready to upgrade your CAD skills?
                                </span>

                                <h2>
                                    Start Your CAD Automation Journey
                                </h2>

                                <p>
                                    Get in touch with our team to know more about
                                    the training, fees and available offers.
                                </p>

                            </div>


                            <Button
                                href="/contact"
                                className="fees-cta-btn"
                            >
                                Contact Us

                                <FiArrowRight />

                            </Button>

                        </div>

                    </Container>

                </section>

            </div>
        </>
    );
}


export default FeesStructure;